// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fdeef6a2","333":"0dbcb3dd"}[chunkId] + ".chunk.js";
};